<template>
  <div>
    <div v-if="searchVisiable" class="container">
      <div class="banner">
        <!-- <img src="../../assets/images/banner_logo.png" /> -->
        <span style="cursor: pointer;">丰湃运单查询</span>
      </div>
      <div class="search">
        <div class="search_box">
          <img class="search_search" src="../../assets/images/searchbar_search.png" />
          <input v-model="order" v-on:input="handleChange($event)" placeholder="请输入需要查询的运单号" placeholder-style="border:none;">
         <img class="search_clear" v-if="order" v-on:click="handleClear" src="../../assets/images/searchbar_delete.png" />
        </div>
      </div>
      <div v-if="!order" class="search_btn">查询</div>
      <div v-if="order" class="search_btn" style="background:rgba(39,116,255,1);" v-on:click="handleSearchPreCheck">查询</div>
    </div>
     <div v-if="orderVisiablse" class="container">
      <div class="has-no-order">
        <div class="has-no-order-fl">
          <img src="../../assets/images/icon_yd.png" /><span>{{order}}</span>
        </div>
        <div class="has-no-order-sl">{{status}}</div>
      </div>
      <div v-if="showRider" class="has-order">
        <img src="../../assets/images/rider_head.png" /><span>{{courier_name}}</span>
        <a style="position:relative;flex:1;display:flex;align-items:center;" :href='`tel:${courier_phone}`'><img style="position:absolute;width:24px;height:24px;right:16px;" src="../../assets/images/rider_phone.png" /></a>
      </div>
      <ul v-if="!showRider" class="router-list-sp">
        <li v-for="(router,i) in router_list" :key="router" class="router-list-item">
          <div class="router-list-item_left">
            <img v-if="router.state_name === '已签收'" src="../../assets/images/line_ok.png" />
            <div v-if="router.state_name !== '已签收'" class="router-list-item_left-dot"></div>
            <div v-if="i !== (router_list.length - 1)" class="router-list-item_left-line"></div>
          </div>
          <div v-if="router.state_name === '已签收'" class="router-list-item_right">
            <span style="width:311px;font-weight:600">{{router.state_name}}</span>
            <span style="width:311px;font-weight:400">{{router.content}}</span>
            <span style="width:311px;height:17px;margin-top:8px;font-size: 12px">{{router.time}}</span>
          </div>
          <div v-if="router.state_name !== '已签收'" class="router-list-item_right-sp">
            <span style="width:311px;font-weight:600">{{router.state_name}}</span>
            <span style="width:311px;font-weight:400">{{router.content}}</span>
            <span style="width:311px;height:17px;margin-top:8px;font-size: 12px">{{router.time}}</span>
          </div>
        </li>
      </ul>
      <ul v-if="showRider" class="router-list">
          <li v-for="router in router_list" :key="router" class="router-list-item">
            <div class="router-list-item_left">
              <img v-if="router.state_name === '已签收'" src="../../assets/images/line_ok.png" />
              <div v-if="router.state_name !== '已签收'" class="router-list-item_left-dot"></div>
              <div v-if="i !== (router_list.length - 1)" class="router-list-item_left-line"></div>
            </div>
            <div v-if="router.state_name === '已签收'" class="router-list-item_right">
              <span style="width:311px;font-weight:600">{{router.state_name}}</span>
              <span style="width:311px;font-weight:400">{{router.content}}</span>
              <span style="width:311px;height:17px;margin-top:8px;font-size: 12px">{{router.time}}</span>
            </div>
            <div v-if="router.state_name !== '已签收'" class="router-list-item_right-sp">
              <span style="width:311px;font-weight:600">{{router.state_name}}</span>
              <span style="width:311px;font-weight:400">{{router.content}}</span>
              <span style="width:311px;height:17px;margin-top:8px;font-size: 12px">{{router.time}}</span>
            </div>
          </li>
        </ul>
    </div>
    <div v-if="isSearchTaskVisible" class="escort-task-map-line">
      <task-detail :task_id="task_id"></task-detail>
    </div>
  </div>
</template>
<script>
import { getOrderDetail, checkOrderType } from './api/index';
import taskDetail from './components/taskDetail.vue';

export default {
  components: {
    taskDetail,
  },
  data() {
    return {
      searchVisiable: true,
      // searchVisiable: false,
      // 搜索转运运单
      orderVisiablse: false,
      // 搜索城配任务
      isSearchTaskVisible: false,
      // isSearchTaskVisible: true,
      order: '', // 单号
      status: '', // 物流状态
      showRider: false,
      courier_name: '', // 骑士name
      courier_phone: '',
      router_list: [],
      last_content: '',
      // 搜索task_id
      // task_id: '16394541620022',
      task_id: '',
    };
  },
  mounted() {
    document.title = '丰湃运单查询';
  },
  methods: {
    handleChange(event) {
      // console.log(event.target.value);
    },
    handleClear() {
      this.order = '';
    },
    handleSearchPreCheck() {
      checkOrderType({ waybill_no: this.order }).then((res) => {
        console.log('res', res);
        if (res.errno === 0) {
          if (res.result === 2) {
            this.handleSearch();
          } else {
            this.searchByTask();
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    searchByTask() {
      document.title = '任务详情';
      this.task_id = this.order;
      this.searchVisiable = false;
      this.isSearchTaskVisible = true;
    },
    handleSearch() {
      const params = {
        code: this.order,
        sys_code: 'h5',
      };
      getOrderDetail(params).then((response) => {
        if (!response.errno) {
          document.title = '运单详情';
          const data = response.result;
          this.searchVisiable = false;
          this.orderVisiablse = true;
          this.status = (data.data && !data.data.length && !data.courier_name) ? '暂无物流' : data.status_name;
          this.courier_name = data.courier_name;
          this.courier_phone = data.courier_phone;
          this.router_list = data && data.data.map(item => ({
            state_name: item.state_name,
            content: item.content,
            time: this.getNowFormatDate(new Date(item.timestamp * 1000)),
            // show_line: (item.content === data.data[data.data.length - 1].content && item.datetime === data.data[data.data.length - 1].datetime) ? false : true,
          }));
          if (data.courier_name) {
            this.showRider = true;
          }
        } else {
          alert(response.data.errmsg);
        }
      });
    },
    getNowFormatDate(date) {
      // 将时间戳转换为日期格式
      const seperator1 = '-';
      const seperator2 = ':';
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      let hour = date.getHours();
      let minite = date.getMinutes();
      let second = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = `0${strDate}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minite >= 0 && minite <= 9) {
        minite = `0${minite}`;
      }
      if (second >= 0 && second <= 9) {
        second = `0${second}`;
      }
      const currentdate = `${date.getFullYear()}${seperator1}${month}${seperator1}${strDate} ${hour}${seperator2}${minite}${seperator2}${second}`;
      return currentdate;
    },
  },
};
</script>

<style lang="less" scoped>
  html, body {
    width: 100%;
    height: 100%;
    background: #fafafa;
  }
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .banner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 400px;
    background-image: url('../../assets/images/bannernew.png');
    // background-repeat: no-repeat;
    background-size: contain;
    color: black;
  }
  @media screen and (min-width: 650px) {
    .banner {
      background-size: 80%;
      // background-position: center;
      // background-size: auto;
      // background-position: center 0;
    }
  }
  .banner img {
    width: 74px;
    height: 120px;
  }
  .banner span {
    font-size:48px;
    font-weight:500;
    color:rgba(255,255,255,1);
  }
  .search {
    position: absolute;
    display: flex;
    align-items: center;
    top: 370px;
    width:686px;
    height:110px;
    background:rgba(255,255,255,1);
    box-shadow:0px 8px 16px 0px rgba(0,90,255,0.06);
    border-radius:8px;
  }
  .search_box {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
  }
  .search_search {
    margin-left: 24px;
  }
  .search_clear {
    position: absolute;
    right:24px;
    cursor:pointer;
  }
  .search img {
    width: 48px;
    height: 48px;
  }
  .search input {
    width: 446px;
    height: 45px;
    margin-left: 20px;
    font-size:32px;
    font-weight:600;
    color:rgba(49,49,51,1);
  }
  .search input::-webkit-input-placeholder{
    font-weight:400;
    color:rgba(222,224,230,1);
  }
  .search input {
    border: none;
  }
  .search input:focus {
    outline: none;
  }
  .search_btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width:360px;
    height:96px;
    background:rgba(39,116,255,.4);
    border-radius:8px;
    margin-top: 138px;
    font-size:40px;
    font-weight:400;
    color:rgba(255,255,255,1);
  }
  .has-no-order {
    box-sizing: border-box;
    padding: 70px 0 0 32px;
    width:100%;
    height:286px;
    background:linear-gradient(180deg,rgba(39,116,255,1) 0%,rgba(0,90,255,0.8) 100%);
  }
  .has-no-order-fl {
    display: flex;
    align-items: center;
  }
  .has-no-order-fl img {
    width: 32px;
    height: 32px;
    margin-right: 4px;
  }
  .has-no-order span {
    font-size:28px;
    font-weight:600;
    color:rgba(255,255,255,1);
  }
  .has-no-order-sl {
    margin-top: 8px;
    font-size:64px;
    font-weight:600;
    color:rgba(255,255,255,1);
  }
  .has-order {
    position: absolute;
    display: flex;
    align-items: center;
    top: 256px;
    width:686px;
    height:128px;
    background:rgba(255,255,255,1);
    box-shadow:0px 8px 16px 0px rgba(0,90,255,0.06);
    border-radius:8px;
  }
  .has-order img {
    width: 76px;
    height: 76px;
    margin-left: 24px;
  }
  .has-order span {
    margin-left: 10px;
    font-size: 32px;
  }
  .router-list {
    display: flex;
    flex-direction: column;
    width: 706px;
    margin-top: 158px;
  }
  .router-list-sp {
    display: flex;
    flex-direction: column;
    width: 706px;
    margin-top: 60px;
  }
  .router-list-item {
    position: relative;
    list-style: none;
    display: flex;
  }
  .router-list-item:last-child {
    margin-bottom: 200px;
  }
  .router-list-item img {
    width: 40px;
    height: 40px;
  }
  .router-list-item_left {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 64px;
  }
  .router-list-item_left-dot {
    width:18px;
    height:18px;
    border-radius: 9px;
    background:rgba(228,228,239,1);
  }
  .router-list-item_left-line {
    width:4px;
    height:200px;
    background:rgba(228,228,239,1);
  }
  .router-list-item_right {
    display: flex;
    flex-direction: column;
    font-size: 28px;
    color:rgba(49,49,51,1);
  }
  .router-list-item_right-sp {
    position: absolute;
    top: -12px;
    left: 64px;
    display: flex;
    flex-direction: column;
    font-size: 28px;
    color:rgba(49,49,51,1);
  }
</style>
